var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_748_1242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_748_1242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 20V11H6.8L8.4 12.6L7 14L3 10L7 6L8.4 7.4L6.8 9H15C15.55 9 16.0208 9.19583 16.4125 9.5875C16.8042 9.97917 17 10.45 17 11V20H15Z",
    fill: "#3A5F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.d1c1020e7ed53b2fa24ef624ba2a5331.svg";
export { ForwardRef as ReactComponent };